import { render, staticRenderFns } from "./endetajinfo.vue?vue&type=template&id=6882e55c&scoped=true&"
import script from "./endetajinfo.vue?vue&type=script&lang=js&"
export * from "./endetajinfo.vue?vue&type=script&lang=js&"
import style0 from "./endetajinfo.vue?vue&type=style&index=0&id=6882e55c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6882e55c",
  null
  
)

export default component.exports